import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Row, Modal } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { messages } from './MasterFooter.i18n';
import { getLocalizedStringContent, getLocalizedFacilityStringContent }
from '../../redux/modules/localization/localization-middleware';

class MasterFooter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      modalContents: '',
      modalTitle: null,
    };
  }

  clickTermsOfUse = () => {
    const callback = (response) => {
      const title = <FormattedMessage {...messages.termsOfUse} />;
      this.setState({ showModal: true, modalContents: response.data, modalTitle: title });
    };

    getLocalizedFacilityStringContent(this.props.facilityId, this.props.languageCode, 'TermsOfUse', callback);
  };

  clickPrivacyStatement = () => {
    const callback = (response) => {
      const title = <FormattedMessage {...messages.privacyStatement} />;
      this.setState({ showModal: true, modalContents: response.data, modalTitle: title });
    };

    getLocalizedFacilityStringContent(this.props.facilityId, this.props.languageCode, 'PrivacyStatement', callback);
  };

  clickAccessibilityHelp = () => {
    const callback = (response) => {
      const title = <FormattedMessage {...messages.accessibilityHelp} />;
      this.setState({ showModal: true, modalContents: response.data, modalTitle: title });
    };

    getLocalizedStringContent(this.props.languageCode, 'Accessibility.Help', callback);
  };

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <Row id="footer">
        <div className="footer">
          <p data-qa-item="copyrightStatement">
            {this.props.copyright}
          </p>
          <a aria-label={ formatMessage(messages.screenReader.termsOfUse) } data-qa-item="touLink"
            onClick={this.clickTermsOfUse} tabIndex={0}
            role="link"
          >
            <FormattedMessage {...messages.termsOfUse} />
          </a>
          &nbsp;|&nbsp;
          <a aria-label={ formatMessage(messages.screenReader.privacyStatement) } data-qa-item="psLink"
            onClick={this.clickPrivacyStatement} tabIndex={0}
            role="link"
          >
            <FormattedMessage {...messages.privacyStatement} />
          </a>
          &nbsp;|&nbsp;
          <a aria-label={ formatMessage(messages.screenReader.accessibilityHelp) } data-qa-item="ahLink"
            onClick={this.clickAccessibilityHelp} tabIndex={0}
            role="link"
          >
            <FormattedMessage {...messages.accessibilityHelp} />
          </a>
        </div>
        <Modal show={ this.state.showModal }
          onHide={ this.closeModal }
          backdrop="static"
          aria-labelledby="pageTitle"
          data-qa-container="modal"
        >
          <Modal.Header closeButton data-qa-item="modal-header">
            <Modal.Title>
              <div id="pageTitle" tabIndex="0">
                {this.state.modalTitle}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body data-qa-item="modal-body">
            <div className="scrollbox" dangerouslySetInnerHTML={{ __html: this.state.modalContents }}></div>
          </Modal.Body>
          <Modal.Footer data-qa-item="modal-footer">
              <button type="button" className="btn btn-default" onClick={this.closeModal}>
                  <FormattedMessage {...messages.closeModalText} />
              </button>
          </Modal.Footer>
        </Modal>
      </Row>
    );
  }
}

MasterFooter.propTypes = {
  intl: PropTypes.object,
  languageCode: PropTypes.string,
  facilityId: PropTypes.number,
  copyright: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageCode: state.language.languageCode,
  facilityId: state.facility.facilityId,
  copyright: state.language.translations ? state.language.translations['copyright.Statement'] : '',
});

export default connect(mapStateToProps)(injectIntl(MasterFooter));